import { styled, Typography } from "@mui/material";
import { PaddedPaper } from "components/surfaces/PaddedPaper";
import { useTranslation } from "react-i18next";
import { BackgroundLayerSelect } from "./BackgroundLayerSelect";
import { SelectBorderLayer } from "./OverlayerSelect";

export function SelectBaseLayerWrapper() {
  const { t } = useTranslation();
  return (
    <StyledPaper>
      <Typography variant="h3">{t("label.backgroundLayers")}</Typography>
      <BackgroundLayerSelect />
      <Typography variant="h3">{t("label.borders")}</Typography>
      <SelectBorderLayer />
    </StyledPaper>
  );
}

const StyledPaper = styled(PaddedPaper)`
  margin-right: ${({ theme }) => theme.spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`;
